import {Dispatch} from 'react';
import {IElementQuestionnaire} from '../../../../../incase-domain/elements/base/questionElementBase';
import {IElementPhotoAnswerQuestion} from '../../../../../incase-domain/elements/question/photoAnswerQuestion';
import {IElementQuestion} from '../../../../../incase-domain/elements/question/question';
import {IPresentation} from '../../../../../incase-domain/presentation';
import {IGameConfig} from '../../../../../incase-domain/proptypes/gameConfig';
import {IRunFile, QuestionElementInteractions, QuestionnaireElementInteraction} from '../../../../../incase-domain/proptypes/runfile';
import {getNewPoints} from '../../../../../service/gamification.service';
import {handleElementsClickedAction} from '../../../../../store/actions/chalkBoardElements.actions';
import {IHandleElementsClicked} from '../../../../../store/actions/types/dashboard.actions.type';
import {isQuestionRetriable, isQuestionRetryLimitReached} from '../../../../../util/util';

export function handleRetryAndResultOnClick(
    element: IElementQuestion | IElementPhotoAnswerQuestion,
    propsClickedAnswers: number[],
    index: number,
    elementInteractions: QuestionElementInteractions,
    runFile: IRunFile,
    gameConfig: IGameConfig | undefined,
    savePresentationRunFile: (elementRunFile: QuestionElementInteractions, newPoints?: number) => void,
    emitRemainingTriesToast: (element: IElementQuestionnaire, elementInteractions: QuestionnaireElementInteraction) => void,
    dispatch: Dispatch<IHandleElementsClicked>,
    presentation: IPresentation | undefined
): void {
    const {answered} = elementInteractions;

    if (element.singleCorrect && isQuestionRetriable(element, presentation)) {
        const clickedAnswers = [...propsClickedAnswers, index];

        const isCorrect = element.answers[index].type === 'correct' || element.answers[index].type === 'debatable';

        let newPoints = runFile.points || 0;
        newPoints = getNewPoints(newPoints, isCorrect, gameConfig || ({} as IGameConfig), element.gameConfig);

        if (isQuestionRetryLimitReached(elementInteractions, element, presentation, answered, isCorrect)) {
            savePresentationRunFile(
                {
                    clickedAnswers,
                    correctAnswers: element.correctAnswers,
                    answered: true,
                    retriedAnswers: elementInteractions.retriedAnswers || [],
                },
                newPoints
            );
        } else if (!isCorrect && !answered) {
            emitRemainingTriesToast(element, elementInteractions);
            savePresentationRunFile(
                {
                    retriedAnswers: [...(elementInteractions.retriedAnswers || []), {attempt: clickedAnswers}],
                    wrongAnswer: index,
                    answered: false,
                },
                newPoints
            );
        }
    }

    if (element.singleCorrect && propsClickedAnswers.length > 0) {
        return;
    }
    if (!propsClickedAnswers.includes(index) && (isQuestionRetriable(element, presentation) || !element.singleCorrect)) {
        let newPoints;
        if (element.answers[index].type === 'debatable') {
            newPoints = runFile.points;
        } else {
            newPoints = getNewPoints(
                runFile.points || 0,
                element.answers[index].type === 'correct',
                gameConfig || ({} as IGameConfig),
                element.gameConfig
            );
        }

        const updatedClickedAnswers = [...propsClickedAnswers, index];
        savePresentationRunFile(
            {
                clickedAnswers: updatedClickedAnswers,
                correctAnswers: element.correctAnswers,
                answered: true,
            },
            newPoints || 0
        );
    }

    dispatch(handleElementsClickedAction([element.id], !!element.clearAfterClicked));
}

export function getCorrectIncorrectAnswerType(
    propsClickedAnswers: number[],
    index: number,
    element: IElementPhotoAnswerQuestion | IElementQuestion
): string {
    const clicked = propsClickedAnswers.includes(index);
    const {type} = element.answers[index];
    let correctClass = 'is-debatable';
    if (type === 'correct') {
        correctClass = 'is-correct';
    } else if (type === 'incorrect') {
        correctClass = 'is-incorrect';
    }

    if (clicked) {
        return correctClass;
    }

    return '';
}
